<script>
import { mapState, mapActions } from 'vuex';
import { map } from 'lodash-es';
import store from '../store';

export default {
  data: () => ({
    snackbar: false,
    saveSuccess: false,
  }),
  computed: {
    ...mapState({
      accommodationProperties: state => state.filter.single.facilities.accommodationProperties,
      accommodationCategories: state => state.filter.single.facilities.accommodationCategories,
      accommodationBedrooms: state => state.filter.single.facilities.accommodationBedrooms,
      siteFacilities: state => state.filter.single.facilities.siteFacilities,
      loading: state => state.filter.singleLoading,
      changed: state => state.filter.single.facilities.changed,
    }),
  },
  methods: {
    ...mapActions({
      setAccommodationProperties: 'filter/setAccommodationProperties',
      setAccommodationCategories: 'filter/setAccommodationCategories',
      setAccommodationBedrooms: 'filter/setAccommodationBedrooms',
      setSiteFacilities: 'filter/setSiteFacilities',
      saveFilterFacilities: 'filter/saveFilterFacilities',
    }),
    setProperty(id, value) {
      this.setAccommodationProperties(
        map([...this.accommodationProperties], property => ({
          ...property,
          selected: property.id === id ? !!value : property.selected,
        })),
      );
    },
    setCategory(id, value) {
      this.setAccommodationCategories(
        map([...this.accommodationCategories], category => ({
          ...category,
          selected: category.id === id ? !!value : category.selected,
        })),
      );
    },
    setBedroom(id, value) {
      this.setAccommodationBedrooms(
        map([...this.accommodationBedrooms], bedroom => ({
          ...bedroom,
          selected: bedroom.id === id ? !!value : bedroom.selected,
        })),
      );
    },
    setFacility(id, value) {
      this.setSiteFacilities(
        map([...this.siteFacilities], facility => ({
          ...facility,
          selected: facility.id === id ? !!value : facility.selected,
        })),
      );
    },
    saveFacilities() {
      this.saveFilterFacilities(this.$route.params.id)
        .then(() => {
          this.saveSuccess = true;
          this.snackbar = true;
        })
        .catch(() => {
          this.saveSuccess = false;
          this.snackbar = true;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('filter/fetchFilterFacilities', to.params.id)
      .then(() => {
        next();
      });
  },
  beforeRouteLeave(to, from, next) {
    return this.$changeDetect(this.changed, next);
  },
};
</script>

<template>
  <div class="filter-edit-facilities">
    <v-form ref="editForm" class="pb-5">
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('filterEdit.facilities.titles.accommodationProperties') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('filterEdit.facilities.descriptions.accommodationProperties') }}
        </div>
        <v-checkbox
          v-for="(property, index) in accommodationProperties"
          :key="'acc-property-' + index"
          :input-value="property.selected"
          :disabled="loading"
          :label="property.name"
          hide-details
          @change="setProperty(property.id, $event)"/>
      </div>
      <v-divider/>
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('filterEdit.facilities.titles.accommodationCategories') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('filterEdit.facilities.descriptions.accommodationCategories') }}
        </div>
        <v-checkbox
          v-for="(category, index) in accommodationCategories"
          :key="'acc-category-' + index"
          :input-value="category.selected"
          :disabled="loading"
          :label="category.name"
          hide-details
          @change="setCategory(category.id, $event)"/>
      </div>
      <v-divider/>
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('filterEdit.facilities.titles.accommodationBedrooms') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('filterEdit.facilities.descriptions.accommodationBedrooms') }}
        </div>
        <v-checkbox
          v-for="(bedroom, index) in accommodationBedrooms"
          :key="'acc-bedroom-' + index"
          :input-value="bedroom.selected"
          :disabled="loading"
          :label="bedroom.name"
          hide-details
          @change="setBedroom(bedroom.id, $event)"/>
      </div>
      <v-divider/>
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('filterEdit.facilities.titles.siteFacilities') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('filterEdit.facilities.descriptions.siteFacilities') }}
        </div>
        <v-checkbox
          v-for="(facility, index) in siteFacilities"
          :key="'acc-facility-' + index"
          :input-value="facility.selected"
          :disabled="loading"
          :label="facility.name"
          hide-details
          @change="setFacility(facility.id, $event)"/>
      </div>
    </v-form>
    <v-btn
      fixed
      bottom
      right
      :loading="loading"
      color="primary"
      @click="saveFacilities">
      Save
    </v-btn>
    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="4000">
      <v-icon v-if="saveSuccess" class="mr-3 green--text">check_circle</v-icon>
      <v-icon v-else class="mr-3 red--text">warning</v-icon>
      {{ saveSuccess
      ? $t('filterEdit.facilities.snackbar.save.success')
      : $t('filterEdit.facilities.snackbar.save.error')
      }}
      <v-btn
        color="white"
        flat
        @click="snackbar = false">
        {{ $t('filterEdit.facilities.snackbar.save.button') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/FilterEditFacilities.vue